import React from 'react'
import { css } from '@emotion/core'

export type SortKeyType = { key: string; order: 'asc' | 'desc' }

type ContainerProps = {
  name: string
  onChange: (sort: SortKeyType) => void
  value: SortKeyType
}

export const SortableTableHeader: React.FC<ContainerProps> = ({ name, onChange, value, children, ...props }) => {
  return (
    <th
      onClick={() => {
        if (value.key === name) {
          onChange({ key: name, order: value.order === 'asc' ? 'desc' : 'asc' })
        } else {
          onChange({ key: name, order: 'asc' })
        }
      }}
      css={containerStyle}
      {...props}
    >
      {children}
      {name === value.key ? (
        <img
          style={{ opacity: 1 }}
          src={value.order === 'asc' ? require('@/static/images/icon_arrow_up_2.svg') : require('@/static/images/icon_arrow_down_2.svg')}
        />
      ) : (
        <img src={require('@/static/images/icon_arrow_up_2.svg')} />
      )}
    </th>
  )
}

const containerStyle = css({
  cursor: 'pointer',
  '> img': {
    width: '1rem',
    marginLeft: 4,
    opacity: 0,
    filter: 'brightness(0) saturate(100%) invert(47%) sepia(0%) saturate(3541%) hue-rotate(185deg) brightness(86%) contrast(101%)',
    position: 'absolute',
    marginTop: -2,
  },
  ':hover': {
    '> img': { opacity: 0.5 },
  },
  ':first-of-type': { paddingLeft: 32 },
})
